import React from "react";
import PropTypes from 'prop-types';
import styled from 'styled-components';

var Label = function Label(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("label", {
    className: className
  }, children);
};

Label.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string
};
var StyledComponent = styled(Label).withConfig({
  displayName: "Label__StyledComponent",
  componentId: "sc-1r0jl4z-0"
})(["", ""], function (props) {
  return props.noWrap && 'white-space: nowrap;';
});
export default StyledComponent;